import { theme } from '@theme';
import { FC, useEffect, useState } from 'react';
import styled from 'styled-components';
import { MakeDetails } from '../../../../types/essential-ui/MakeDetails';
import { Icon, Typography } from '../../../style';

type MakeProps = {
  data: Array<MakeDetails>;
  headerName?: string;
  onSelectMake: Function;
  warningMsgList?: string[];
};

const SelectMake: FC<MakeProps> = (props) => {
  const makes = props.data;
  const getInitialMakeColor = () => {
    return (
      makes &&
      makes.map((make) => {
        return theme.palette.mediumGray;
      })
    );
  };
  const [makeColor, setMakeColor] = useState(getInitialMakeColor());

  useEffect(() => {
    if (props.data.length === 1) {
      handleClick(props.data[0]);
    }
  }, [props.data]);

  const handleOver = (index) => {
    let tempMakes = getInitialMakeColor();
    tempMakes[index] = theme.palette.white;
    setMakeColor(tempMakes);
  };

  const handleLeave = (index) => {
    let tempMakes = getInitialMakeColor();
    tempMakes[index] = theme.palette.mediumGray;
    setMakeColor(tempMakes);
  };

  const handleClick = (make) => {
    props.onSelectMake(make);
  };

  return (
    <>
      <SelectMakeWrapper data-testid='select-make'>
        {props.headerName && (
          <SectionHeaderWrapper data-testid='select-make-section-header'>
            <Typography
              size={theme.typography.fontSize20}
              fontWeight={theme.typography.fontWeights.normal}
              color={theme.palette.wetAsphalt}
            >
              {props.headerName}
            </Typography>
          </SectionHeaderWrapper>
        )}
        <div data-testid='select-make-header' className='select-make-header'>
          <Typography
            size={theme.typography.fontSize16}
            fontWeight={theme.typography.fontWeights.bold}
            color={theme.palette.wetAsphalt}
          >
            Select Make
          </Typography>
          {props.warningMsgList &&
            props.warningMsgList.length > 0 &&
            props.warningMsgList.map((e, index) => (
              <div key={index}>
                <Typography
                  size={theme.typography.fontSize14}
                  fontWeight={theme.typography.fontWeights.semibold}
                  color={theme.palette.red}
                >
                  {e}
                </Typography>
              </div>
            ))}
        </div>
        <SelectMakeDetailsWrapper data-testid='selct-make-details'>
          {makes.map((make, i) => {
            return (
              <div
                className='card'
                key={i}
                title={
                  make.dealerId.startsWith('OB')
                    ? `${make.dealerId}`
                    : `${make.dealerId} ${make.brandName}`
                }
                onMouseOver={() => handleOver(i)}
                onMouseLeave={() => handleLeave(i)}
                onClick={() => handleClick(make)}
              >
                <div className='makeName'>
                  <TextWrappingDiv>
                    <Typography
                      data-testid='make-name'
                      size={theme.typography.h4}
                      fontWeight={theme.typography.fontWeights.normal}
                      color={makeColor[i]}
                    >
                      {make.brandName}
                    </Typography>
                  </TextWrappingDiv>
                  <RightAlignedDiv>
                    <Icon
                      color={makeColor[i]}
                      data-testid='make-arrow-icon'
                      type='angle-right'
                      size={16}
                    />
                  </RightAlignedDiv>
                </div>
              </div>
            );
          })}
        </SelectMakeDetailsWrapper>
      </SelectMakeWrapper>
    </>
  );
};

export default SelectMake;

const SelectMakeWrapper = styled.div`
  display: flex;
  align-self: baseline;
  width: 100%;
  flex-direction: column;
  justify-content: center;
  margin: 0;
  align-items: center;

  .select-make-header {
    margin-bottom: 24px;
    text-align: center;
  }
`;

const SectionHeaderWrapper = styled.div`
  display: flex;
  align-self: flex-start;
  margin: 22px 0 74px 15px;
`;

const SelectMakeDetailsWrapper = styled.div`
  .card {
    width: 400px;
    padding: 14px 9px 14px 14px;
    margin: 0 0 9px;
    background: ${theme.palette.white};
    border-radius: 5px;
    box-shadow: 0 1px 3px 0 rgb(0 0 0 / 20%);
  }

  .card:hover {
    background: ${theme.palette.darkPurpleEUI};
    cursor: pointer;
  }

  .makeName {
    display: flex;
    align-items: center;
    padding-bottom: '4px';
    height: '28px';
    max-height: 28px;
  }
`;

const RightAlignedDiv = styled.div`
  margin-left: auto;
  margin-top: 2px;
`;

const TextWrappingDiv = styled.div`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;
